export const accountSetup = {
  payments: {
    planUnavailableTitle: "Función no disponible en tu plan",
    planUnavailableMessage:
      "La opción de cobros a huéspedes vía Stripe está disponible solo en planes Standard y superiores. Actualiza tu plan para activar esta función y empezar a cobrar de forma directa, sin intermediarios.",
  },
  modalConnection: {
    header: "Conectar un PMS",
    loaderMessage: "Guardando información, por favor espere.",
    selectPmsLabel: "Selecciona un sistema PMS",
    selectPmsPlaceholder: "Selecciona un PMS",
    apiKeyLabel: "API Key de {pms}",
    apiKeyPlaceholder: "Ingresa tu API Key",
    cancel: "Cancelar",
    save: "Guardar conexión",
    fieldRequired: "Campo requerido",
    selectPmsError: "Selecciona un PMS",
    apiKeyError: "Por favor ingresa la API Key ",
    savedTitle: "Conexión guardada",
    savedMessage: "La conexión se guardó correctamente",
    saveFailMessage: "No se pudo guardar la conexión",
    errorTitle: "Error",
    serverError: "Error al conectar con el servidor",
  },
  subscription: {
    title: "Mi suscripción",
    subtitle: "Consulta y gestiona tu plan, método de pago y facturación.",
    statusActive: "Activa",
    // Cancelada pero todavía dentro de lo que ya pagó: ni «Activa» ni «Cancelada» a secas.
    statusCanceledValid: "Cancelada · activa hasta",
    validUntil: "Activa hasta:",
    statusPaymentPending: "Pago pendiente",
    statusTrial: "Periodo de prueba",
    statusNone: "Sin suscripción activa",
    intervalYearly: "Plan anual",
    intervalMonthly: "Plan mensual",
    perMonthShort: "/mes",
    nextRenewal: "Próxima renovación:",
    servicesIncluded: "Servicios incluidos",
    units: "unidad | unidades",
    perUnitSuffix: "/unidad",
    serviceFallback: "Servicio",
    manageOpening: "Abriendo…",
    manageButton: "Administrar suscripción y facturas",
    emptyText:
      "Aún no tienes un plan activo. Elige uno para empezar a recibir check-ins y cobros.",
    buyPlan: "Comprar un plan",
    types: {
      apartment: "Apartamento",
      hotel: "Hotel",
      room: "Habitación",
      camping: "Camping",
      villa: "Villa",
      chatbot: "Recepción IA",
    },
  },
  purchased: {
    title: "Disponibles en tu suscripción",
    subtitle: "Cupo contratado y uso actual",
    accommodations: "Alojamientos",
    empty: "Aún no has creado alojamientos.",
    createProperty: "Crear propiedad",
    adjust: "Ajustar",
    loadError: "No se pudo cargar la información.",
    labels: {
      apartment: "Apartamento(s)",
      hotel: "Hotel (Habitaciones)",
      hotelPack: "Hotel (Habitaciones) · #{id}",
      villa: "Villas",
      camping: "Campings",
      campingPack: "Campings · #{id}",
      chatbot: "Licencias Chatbot",
    },
    units: {
      unid: "unid.",
      room: "hab.",
      spots: "plazas",
      licenses: "licencias",
    },
    types: {
      hotel: "Hotel",
      camping: "Camping",
      villa: "Villa",
      apartment: "Apartamento",
    },
    badge: {
      rooms: "{n} hab.",
      spots: "{n} plazas",
      unit: "1 unidad",
    },
  },
  notifications: {
    title: "Notificaciones",
    description: "Activa o desactiva automatizaciones de mensajería y avisos.",
    loading: "Cargando configuración...",
    alwaysActive: "Siempre activo",
    active: "Activo",
    inactive: "Inactivo",
    hint:
      "Nota: algunas automatizaciones se muestran como informativas porque ya forman parte del flujo estándar del sistema.",
    loadError: "No se pudo cargar la configuración.",
    saveError: "No se pudo guardar el cambio. Reintentando...",
    items: {
      whatsapp_booking_confirmation: {
        title: "Confirmación de reserva (WhatsApp)",
        description:
          "Envía automáticamente la plantilla de confirmación cuando una reserva queda confirmada.",
      },
      email_checkin_sent: {
        title: "Notificaciones por correo al enviar el check-in",
        description:
          "Envía un correo automático cuando se completa o se envía el proceso de check-in.",
      },
      whatsapp_checkin_link_auto: {
        title: "Enviar WhatsApp automático del check-in online",
        description:
          "Envía automáticamente el enlace del check-in online por WhatsApp cuando corresponde.",
      },
      checkin_link_send_policy: {
        title: "Política de envío del link de check-in para reservas directas",
        description:
          "Define si el enlace se envía siempre o solo cuando la reserva esté paga o parcialmente paga.",
        options: {
          always: {
            label: "Siempre enviar",
            description:
              "Envía el link de check-in sin depender del estado de pago.",
          },
          paid_or_partially_paid: {
            label: "Solo pagada o parcialmente paga",
            description:
              "Envía el link solo si la reserva está pagada total o parcialmente. Aplica solo a reservas directas.",
          },
        },
      },
    },
  },
  wompi: {
    country: "Colombia",
    statusVerified: "Conectada",
    statusPending: "Sin verificar",
    publicKeyLabel: "Public Key",
    privateKeyLabel: "Private Key",
    keepPrivateLabel: "Mantener la privada guardada (no se muestra por seguridad)",
    privatePlaceholderSaved: "•••••••••••• (guardada)",
    btnDisconnect: "Desconectar",
    btnVerify: "Verificar cuenta",
    btnSave: "Guardar credenciales",
    merchantHeader: "Comercio detectado",
    missingPublicKey: "Falta Public Key",
    missingPrivateKey: "Falta Private Key",
    savedOk: "Credenciales guardadas correctamente",
    saveError: "Error al guardar las credenciales",
    verifiedOk: "Cuenta verificada",
    notVerified: "Cuenta no verificada",
    verifyError: "Error al verificar la cuenta",
    disconnectConfirm: "¿Estás seguro de desconectar Wompi de este negocio?",
    disconnectedOk: "Desconectado correctamente",
    disconnectError: "Error al desconectar",
  },
  pricelabs: {
    subtitle: "Optimización dinámica de precios",
    statusConnected: "Conectado",
    statusDisconnected: "No conectado",
    loading: "Cargando configuración...",
    emailLabel: "Email de PriceLabs",
    emailPlaceholder: "tu-email@pricelabs.com",
    importantTitle: "Importante:",
    bullet1: "Asegúrate de configurar completamente tus propiedades",
    bullet2: "Elige qué anuncios quieres llevar a PriceLabs",
    bullet3:
      "Los precios se actualizarán según PriceLabs y no se podrán editar de forma manual desde Wacheckin",
    btnConnect: "Conectar y Sincronizar",
    btnConnecting: "Conectando...",
    btnSync: "Sincronizar",
    btnSyncing: "Sincronizando...",
    btnDisconnect: "Desconectar",
    btnDisconnecting: "Desconectando...",
    emailRequired: "Por favor ingresa tu email de PriceLabs",
    emailRequiredTitle: "Email requerido",
    connectHeader: "¿Conectar con PriceLabs?",
    connectMessage:
      "Se vincularán todas tus propiedades y habitaciones activas. Se sincronizarán tarifas y disponibilidad. Cualquier propiedad/habitación creada después se enviará automáticamente.",
    connectAccept: "Sí, conectar",
    cancel: "Cancelar",
    linkError: "Error al vincular unidades",
    emailNotFoundConnect:
      "PriceLabs respondió que el email no existe. Revisa tu email e inténtalo de nuevo.",
    emailInvalidTitle: "Email de PriceLabs inválido",
    syncSuccess: "Tus propiedades ahora están conectadas con PriceLabs.",
    syncSuccessTitle: "¡Sincronización completada!",
    syncFail: "No se pudo completar la sincronización",
    errorTitle: "Error",
    emailNotFoundManual:
      "PriceLabs indicó que el email no existe. Corrige el email y vuelve a sincronizar.",
    manualSuccess: "El proceso se completó correctamente.",
    manualSuccessTitle: "Sincronización manual",
    manualFail: "No se pudo sincronizar con PriceLabs",
    rejected: "PriceLabs rechazó {count} anuncio(s). {detail}",
    rejectedTitle: "No se pudo sincronizar",
    nothingSent: "No se envió ningún anuncio. Revisa que los que elegiste tengan precio y moneda.",
    relinked: "{count} anuncio(s) seguían atados a otra cuenta de PriceLabs: se han llevado con un identificador nuevo, así que allí aparecen como anuncios nuevos.",
    relinkedTitle: "Identificador nuevo",
    syncedAt: "Sincronizado · {when}",
    notSyncedYet: "Conectado, pendiente de enviar",
    noneSelected: "No has elegido ningún alojamiento. Marca los que quieras llevar a PriceLabs y vuelve a sincronizar.",
    disconnectHeader: "¿Desconectar PriceLabs?",
    disconnectMessage: "Se desvincularán todas tus propiedades de PriceLabs.",
    disconnectAccept: "Sí, desconectar",
    disconnectedOk: "Tu cuenta ha sido desconectada de PriceLabs",
    disconnectedTitle: "Desconectado",
    disconnectFail: "No se pudo desconectar de PriceLabs",
    noErrorsReported: "Sin errores reportados.",
    listingPrefix: "Listing {id}: ",
    unknownError: "Error desconocido",
    listTitle: "Qué anuncios van a PriceLabs",
    listHint: "Elige cuáles quieres que PriceLabs gestione. Los que dejes apagados conservan sus precios y los editas tú.",
    listCount: "{n} de {total} elegidos",
    listSearch: "Buscar un alojamiento o una habitación…",
    listRooms: "{n} habitaciones",
    listApartment: "Apartamento",
    listEmpty: "Todavía no tienes alojamientos.",
    listNoMatch: "Ningún alojamiento con ese nombre.",
    listNeedsCurrency: "Le falta la moneda",
    listNeedsRate: "Le falta una tarifa",
    btnConnectN: "Conectar y sincronizar | Conectar y sincronizar {n} | Conectar y sincronizar {n}",
    unitConnected: "{name} ya va a PriceLabs",
    unitDisconnected: "{name} ya no va a PriceLabs",
    unitFail: "No se ha podido cambiar. Vuelve a intentarlo.",
    listLocked: "Conecta tu cuenta de PriceLabs y aquí podrás elegir qué anuncios gestiona.",
    listAll: "Todos",
    listNone: "Ninguno",
    btnSyncN: "Sincronizar | Sincronizar 1 anuncio | Sincronizar {n} anuncios",
    connectedOk: "Cuenta conectada. Ahora elige qué anuncios van a PriceLabs.",
    connectedTitle: "Listo",
  },
};
